import { render } from "./mybutton.vue?vue&type=template&id=60c81b50&scoped=true"
import script from "./mybutton.vue?vue&type=script&lang=js"
export * from "./mybutton.vue?vue&type=script&lang=js"

import "./mybutton.vue?vue&type=style&index=0&id=60c81b50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c81b50"]])

export default __exports__